import React from "react";
import logoSrc from '../img/logo.png';
import './Blog.css';

function Research() {
  return (
    <>
    <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Blogs Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />
      </div>
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">Shigjeta research services</h1>
            <p className="banner-description">
              Unlock valuable insights and data-driven solutions with Shigjeta's research services. We analyze trends, patterns, and strategies to help you make informed decisions.
            </p>
            <a href="/research" className="banner-button">
              Learn More About Our Research
            </a>
          </div>
          {/* Background Image */}
          <div className="banner-background"></div>
        </div>
      </section>

      {/* Research Section */}
      <section className="about-section">
        {/* Section 1: Market Research */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Comprehensive Market Research</strong></h2>
            <p>
              Our research provides deep insights into market trends, helping businesses adapt and thrive in a competitive landscape.
            </p>
            <ul>
              <li><strong>Target Audience Analysis:</strong> Understanding customer behavior and needs.</li>
              <li><strong>Competitor Analysis:</strong> Identify key players and market gaps.</li>
              <li><strong>Trend Forecasting:</strong> Stay ahead with predictive market insights.</li>
            </ul>
            <button className="cta-button">Start Your Research</button>
          </div>
          <div className="about-image">
            <img src="market-research.jpg" alt="Market Research" />
          </div>
        </div>

        {/* Section 2: Data Analytics */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Data Analytics for Growth</strong></h2>
            <p>
              Leverage data to improve decision-making and optimize business operations. We provide actionable insights to maximize performance.
            </p>
            <ul>
              <li><strong>Performance Metrics:</strong> Measure the success of key initiatives.</li>
              <li><strong>Data Visualization:</strong> Transform raw data into actionable charts.</li>
              <li><strong>Operational Insights:</strong> Streamline processes with data-backed solutions.</li>
            </ul>
            <button className="cta-button">Discover Data Insights</button>
          </div>
          <div className="about-image">
            <img src="data-analytics.jpg" alt="Data Analytics" />
          </div>
        </div>

        {/* Section 3: Strategic Research */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Strategic Research & Planning</strong></h2>
            <p>
              Our research is designed to assist businesses in formulating successful long-term strategies that foster growth and sustainability.
            </p>
            <ul>
              <li><strong>Strategic Planning:</strong> Build informed strategies for success.</li>
              <li><strong>Market Entry Research:</strong> Navigate new markets with confidence.</li>
              <li><strong>Risk Analysis:</strong> Identify and mitigate potential risks.</li>
            </ul>
            <button className="cta-button">Start Strategic Planning</button>
          </div>
          <div className="about-image">
            <img src="strategic-research.jpg" alt="Strategic Research" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Research;
